import $ from "cash-dom";
import Ajax from "../components/ajax";

$(function () {
    let container = document.getElementById('sponsor-ad');

    if (container) {
        if (!container.offsetHeight) {
            Ajax.post(ajaxurl, {
                action: "block-logger",
                enabled: 1,
            }, function (response) {});
        }

        container.remove();
    }
});